import Vue from "vue";
import Landing from "@/views/Landing.vue";
import "./scss/custom.scss";
import "../public/css/overmatch.css";
import i18n from "./i18n";

Vue.config.productionTip = false;

new Vue({
  i18n,
  render: h => h(Landing)
}).$mount("#app");
